<template>
  <section class="InvestmentDetails">
    <Wrap class="lg">
      <h3>
        {{ $t('title') }}
      </h3>

      <div class="details-wrapper">
        <!-- <table class="details">
          <tr>
            <th v-for="(header, index) in $t('headers')" :key="index">
              {{ header }}
            </th>
          </tr>
          <tr>
            <td v-for="(value, index) in $t('values')" :key="index">
              {{ value }}
            </td>
          </tr>
        </table> -->
        <table class="details">
          <tr v-for="(detail, index) in $t('details')" :key="index">
            <th>{{ detail[0] }}</th>
            <td>{{ detail[1] }}</td>
          </tr>
        </table>
      </div>
    </Wrap>
  </section>
</template>

<script>
export default {
  components: {},
}
</script>

<style lang="scss">
.InvestmentDetails {
  .details-wrapper {
    display: flex;
    justify-content: center;
    padding: 3rem 0;

    table.details {
      min-width: 50vw;

      th, td {
        border: 2px solid $main;
        padding: 1.5rem;
        text-align: center;
        @include lg {
          font-size: $h5;
        }
      }

      th {
        width: 65%;
        @include lg {
          width: 75%;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Investment details",
    "details": [
      [
        "The amount of the portion of the bond issue to be distributed",
        "5 million euros"
      ],
      [
        "Maturity date",
        "12 months"
      ],
      [
        "Annual interest rate",
        "13%"
      ],
      [
        "Coupon payment rate",
        "Semi-annual"
      ],
      [
        "Minimum investment amount",
        "1000 euro"
      ]
    ]
  },
  "lt": {
    "title": "Investicijos detalės",
    "details": [
      [
        "Platinamos obligacijų emisijos dalies suma",
        "5 mln. Eur"
      ],
      [
        "Emisijos trukmė",
        "12 mėn"
      ],
      [
        "Metinės palūkanos",
        "13%"
      ],
      [
        "Kuponų mokėjimai",
        "Pusmetiniai"
      ],
      [
        "Minimali investicijos suma",
        "1000 eurų"
      ]
    ]
  }
}
</i18n>
